export const PATHS = {
  default: () => "/",
  merchant: () => "/merchant",
  merchantLevel: () => "/merchant-level",
  merchantFeeDetail: () => "/merchant-level/:id",
  consumer: () => "/consumer",
  store: () => "/store",
  storeDetail: () => "/store/:id",
  storeOnboardDetail: () => "/store-onboarding/:id",
  storeUpdateDetail: () => "/store-update/:id",
  adminEditUpdateStoreDetail: () => "/store-update/admin-edit/:id",
  adminEditOnboardStoreDetail: () => "/store-onboarding/admin-edit/:id",
  notification: () => "/notification",
  categoryAndAttribute: () => "/category-and-attribute",
  categoryDetail: () => "/category-and-attribute/category/:id",
  merchantDetail: () => "/merchant/:id",
  onboardDetail: () => "/merchant/onboard-request/:id",
  updateInformationDetail: () => "/merchant/update-information/:id",
  login: () => "/login",
  productManagement: () => "/product-management",
  reconciliation: () => "/settlement-report",
  reconciliationMerchantByDate: () => "/settlement-report/merchants",
  reconciliationStoreByDate: () => "/settlement-report/stores/:merchantId",
  reconciliationOrderByDate: () =>
    "/settlement-report/stores/orders/:settlementId/merchant/:merchantId",
  reconciliationDetail: () => "/settlement-report/detail/:id",
  dashboardConfig: () => "/dashboard-config",
  parameters: () => "/parameters",
  emailTemplate: () => "/email-template",
  emailTemplateDetail: () => "/email-template/:id",
  report: () => "/report",
  appVersion: () => "/app-version",
  reportUserMonthly: () => "/report/user-monthly",
  reportUserDaily: () => "/report/user-daily",
  reportDetail: () => "/report/:id",
  reportMerchantDetail: () => "/report/merchant/:id",
  configMenu: () => `/config-menu/:index`,
  configFeaturedRestaurants: () => "/config-featured-restaurants/:index",
  configTopSellingDishes: () => "/config-top-selling-dishes/:index",
  configSurplus: () => "/config-surplus/:index",
  forgotPassword: () => "/forgot-password",
  forgotSuccess: () => "/forgot-success",
  resetPassword: () => "/auth/reset-password",
  lpCashOut: () => "/lp-management",
  role: () => "/role",
  member: () => "/member",
  memberOnboard: () => "/auth/onboard/:id",
  logisticFee: () => "/logistic-fee",
  createMerchant: () => "/create-merchant",
  createStore: () => "/create-store/:id",
  editStore: () => "/edit-store/:id",
  createProduct: () => "/create-product/:id",
  editProduct: () => `/edit-product/:id/:productId`,
  platformFeeManagement: () => "/fee-management",
  refund: () => "/refund",
  listOrders: () => "/list-orders",
  refundDetail: () => "/refund/:id",
};
